const FINAL_MINUTES = 5;
const MINUTE_MILLISECONDS = 60 * 1000;

const remainingTimeConstants = {
    FINAL_MINUTES_MODE_MILLISECONDS: (FINAL_MINUTES + 1) * MINUTE_MILLISECONDS,
    FINAL_MINUTES,
    MINUTE_MILLISECONDS,
    SHOW_SECONDS_TIME_REMAINING_UPDATE_INTERVAL: 400,
    TIME_REMAINING_UPDATE_FROM_SERVER_INTERVAL: 60 * 1000,
    TIME_REMAINING_UPDATE_INTERVAL: 20 * 1000,
};

export default remainingTimeConstants;
